import React, { Component, useState } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import {
  APIHandler,
  BackButton,
  PremiumHotel,
  FreeHotel,
  StorageHandler,
} from "C4";
import { baseAppId, storageKeys } from "settings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Multiselect } from "multiselect-react-dropdown";
import i18n from "i18n-react";

import SimpleBarReact from "simplebar-react";
import "simplebar/src/simplebar.css";

import MarkerFree from "assets/images/ab-mapGrey.png";
import ClusterFree from "assets/images/ab-mapClusterGrey.png";
import MarkerPremium from "assets/images/ab-map.png";
import ClusterPremium from "assets/images/ab-mapCluster.png";

let containerStyle = {
  width: "100%",
  height: "calc(100vh - 8rem)",
};
const params = new URLSearchParams(window.location.search);
if (params.get("mobile")) {
  containerStyle = {
    width: "100%",
    height: "100vh",
  };
}

const clusterPremium = {
  styles: [
    {
      url: ClusterPremium,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

const clusterFree = {
  styles: [
    {
      url: ClusterFree,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

const checkboxOptions = [
  { name: "Accommodations", id: "Accommodations" },
  { name: "Attractions", id: "Attractions & Activities" },
  { name: "Tour & Transport", id: "Transportation" },
  { name: "Dining", id: "Dining" },
];

export default class DirectoryView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      premiumHotelsList: [],
      freeHotelsList: [],
      lat1: 34.29603038454782,
      lat2: 33.3720586039248,
      lon1: -117.38922118652344,
      lon2: -118.43978881347657,
      loading: false,
      query: "",
      category: [],
      width: null,
      mobile: false,
      source: false,
      zoom: 9,
      center: {
        lat: 33.835293,
        lng: -118.194505,
      },
      color: "0096bb",
      font: "Source Sans Pro",
      userInfo: "",
      accommodations: [],
      attractions: [],
      dining: [],
      watersports: [],
      tours: [],
      accoOptions: [
        { name: "Condominium/Apartment", id: "accommodations" },
        { name: "Guest House/Villa", id: "accommodations" },
        { name: "Hotel/Resort", id: "accommodations" },
        { name: "Property Management Company", id: "accommodations" },
      ],
      attractionsOptions: [
        { name: "Beaches", id: "attractions" },
        { name: "Culture & History", id: "attractions" },
        { name: "Family", id: "attractions" },
        { name: "Museum & Arts", id: "attractions" },
        { name: "Nature & Parks", id: "attractions" },
        { name: "Popular", id: "attractions" },
      ],
      diningOptions: [
        { name: "American", id: "dining" },
        { name: "Asian", id: "dining" },
        { name: "Bakery", id: "dining" },
        { name: "Barbecue", id: "dining" },
        { name: "Bars/Pubs", id: "dining" },
        { name: "Café/Deli", id: "dining" },
        { name: "Caribbean", id: "dining" },
        { name: "Catering", id: "dining" },
        { name: "Caymanian", id: "dining" },
        { name: "European", id: "dining" },
        { name: "Farm-to-Table", id: "dining" },
        { name: "Fast Food", id: "dining" },
        { name: "Food Truck", id: "dining" },
        { name: "Italian", id: "dining" },
        { name: "Juice Bar/Smoothies", id: "dining" },
        { name: "Mediterranean", id: "dining" },
        { name: "Mexican", id: "dining" },
        { name: "Pastries/Desserts", id: "dining" },
        { name: "Pizza", id: "dining" },
        { name: "Seafood", id: "dining" },
        { name: "Vegetarian/Vegan", id: "dining" },
      ],
      watersportsOptions: [
        { name: "Diving", id: "watersports" },
        { name: "Snorkelling", id: "watersports" },
        { name: "Red Sail Sports", id: "watersports" },
      ],
      toursOptions: [{ name: "Miscellaneous Tours", id: "tours" }],
      filterOpen: false,
      logo: null,
    };

    this.onSelect = this.onSelect.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    let mobile = false;
    if (params.get("mobile")) {
      mobile = true;
    }
    this.setState({ mobile: mobile, width: width });

    if (width < 800) {
      this.getHotelsList();
    }
    this.getLogo();

    if (params.get("source")) {
      this.setState({ source: JSON.parse(params.get("source")) });
    }
  }

  async getLogo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logoWhite,
      });
    }
  }

  handleInputChange = () => {
    this.setState(
      {
        query: this.search.value,
      },
      this.getHotelsList()
    );
  };

  loadProperties(bounds, zoom) {
    this.setState({
      lat1: bounds.getNorthEast().lat(),
      lat2: bounds.getSouthWest().lat(),
      lon1: bounds.getNorthEast().lng(),
      lon2: bounds.getSouthWest().lng(),
      zoom: zoom,
    });
    this.getHotelsList();
  }

  getHotelsList() {
    this.setState({ loading: true });
    setTimeout(() => {
      const { lat1, lat2, lon1, lon2, query, category } = this.state;
      APIHandler.getFreeHotelsList(
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category
      ).then((results) => {
        this.setState({ freeHotelsList: results, loading: false });
      });
    }, 200);

    // APIHandler.getPremiumHotelsList(lat1, lat2, lon1, lon2).then((results) => {
    //   this.setState({ premiumHotelsList: results.items });
    // });
  }

  flyToMarker = (lat, lon) => {
    this.setState({
      zoom: 15,
      center: {
        lat: Number(lat),
        lng: Number(lon),
      },
    });
  };

  resetMap = () => {
    this.setState({
      zoom: 10,
      center: {
        lat: 33.835293,
        lng: -117.914505,
      },
    });
  };

  resetFilters = () => {
    window.location.reload(false);
  };

  premiumInfo = (userInfoID) => {
    document.getElementById("iframe").classList.remove("hide");
    this.setState({
      userInfo: `https://travproconnect.com/profile/${userInfoID}?app_id=${baseAppId}`,
    });
  };

  freeInfo = (userInfoID) => {
    console.log(userInfoID);
    if (this.state.mobile) {
      window.ReactNativeWebView.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10&mobile=true&header=false`,
        "*"
      );
      window.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=100&mobile=true&header=false`,
        "*"
      );
    } else {
      document.getElementById("iframe").classList.remove("hide");
      this.setState({
        userInfo: `https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
      });
    }
  };

  onSelect(selectedList, selectedItem) {
    this.setState(
      {
        [selectedItem.id]: [
          ...this.state[selectedItem.id],
          selectedItem["name"],
        ],
      },
      () => {
        this.getHotelsList();
      }
    );
  }

  onRemove(selectedList, removedItem) {
    const array = [...this.state[removedItem.id]];
    const index = array.indexOf(removedItem["name"]);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState(
        {
          [removedItem.id]: array,
        },
        () => {
          this.getHotelsList();
        }
      );
    }
  }

  handleCheck = (e) => {
    if (e.target.id !== "") {
      if (this.state.category.includes(e.target.id)) {
        let filteredArray = this.state.category.filter(
          (item) => item !== e.target.id
        );
        this.setState(
          {
            category: filteredArray,
          },
          () => {
            this.getHotelsList();
          }
        );
      } else {
        if (e.target.id !== "") {
          this.setState(
            {
              category: this.state.category.concat([e.target.id]),
            },
            () => {
              this.getHotelsList();
            }
          );
        }
      }
    }
  };

  closeIframe() {
    document.getElementById("iframe").classList.add("hide");
  }

  toggleFilter = () => {
    this.setState({
      filterOpen: !this.state.filterOpen,
    });
  };

  render() {
    const {
      premiumHotelsList,
      freeHotelsList,
      zoom,
      center,
      userInfo,
      mobile,
      width,
      loading,
      filterOpen,
      logo,
      source,
    } = this.state;

    return (
      <div className="directoryContainer">
        {source && (
          <style>{".cookieConsent { display: none !important; } "}</style>
        )}
        {mobile && (
          <style>
            {
              "\
        .cookieConsent { display: none !important; } .directoryContainer { height: 100vh; } .results { top: 0 !important; } .listContainer { height: calc(100vh - 8rem) !important; }"
            }
          </style>
        )}
        {!mobile && (
          <div className="header">
            {!source && (
              <BackButton to="/main" text={i18n.translate("general.back")} />
            )}
            <div className="search">
              <FontAwesomeIcon
                icon={["fas", "search"]}
                className="searchIcon"
              />
              <input
                className="searchInput"
                placeholder={i18n.translate("directoryView.search")}
                type="text"
                ref={(input) => (this.search = input)}
                onChange={this.handleInputChange}
              />
            </div>
            <img src={logo} className="logo" alt="logo" />
          </div>
        )}
        <div className="directoryView">
          <div className="leftSide">
            <div className="results">
              {i18n.translate("directoryView.amountOfResults")}{" "}
              {freeHotelsList.length + premiumHotelsList.length}
              <button
                onClick={filterOpen ? this.toggleFilter : this.toggleFilter}
                className="filter-btn"
              >
                {filterOpen
                  ? i18n.translate("general.close")
                  : i18n.translate("directoryView.filter")}
              </button>
            </div>
            <div className="leftGrid">
              <div className={`filterContainer ${filterOpen ? "active" : ""}`}>
                <div className="checkboxOptions">
                  <span className="title">
                    {i18n.translate("directoryView.filters")}
                  </span>
                  {checkboxOptions.map((option, index) => (
                    <div key={index} className="checkboxDiv" id={option.id}>
                      <label id={option.id} onClick={this.handleCheck}>
                        <span className="labelName" id={option.id}>
                          {i18n.translate(
                            `directory.${option.name
                              .replace(/\s/g, "")
                              .replace(/&/g, "")
                              .replace(/,/g, "")
                              .replace(/&/g, "")
                              .replace(/,/g, "")
                              .replace(/-/g, "")
                              .replace("+", "")
                              .replace(/:/g, "")
                              .toLowerCase()}`
                          )}
                        </span>
                        <input
                          type="checkbox"
                          name={option.name}
                          onChange={this.handleCheck}
                        />
                        <span
                          className="checkmark"
                          id={option.id}
                          onClick={this.handleCheck}
                        />
                      </label>
                    </div>
                  ))}
                </div>

                <div
                  className="resetFilters"
                  onClick={() => {
                    this.resetFilters();
                  }}
                >
                  {i18n.translate("directoryView.resetFilters")} &gt;
                </div>
                <div className="text-center">
                  <button
                    onClick={this.resetFilters}
                    className="filter-btn inverted"
                  >
                    {i18n.translate("directoryView.resetFilters")}
                  </button>
                  <button onClick={this.toggleFilter} className="show-results">
                    {i18n.translate("directoryView.showResults")}
                  </button>
                </div>
              </div>

              <SimpleBarReact
                className={`listContainer ${filterOpen ? "filterOpen" : ""}`}
              >
                <div className="premiumList">
                  {loading && (
                    <span className="loader">
                      <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
                    </span>
                  )}
                  {premiumHotelsList.length > 0 &&
                    premiumHotelsList.map((hotel) => (
                      <PremiumHotel
                        key={hotel.id}
                        id={hotel.id}
                        bgImage={hotel.headerImages[0]}
                        propertyName={hotel.propertyName}
                        flyToMarker={() => {
                          this.flyToMarker(
                            hotel.coords.latitude,
                            hotel.coords.longitude
                          );
                        }}
                        hotelInfo={() => {
                          this.premiumInfo(hotel.userInfoID);
                        }}
                      />
                    ))}
                </div>
                <div className="freeList">
                  {freeHotelsList.length === 0 && !loading && (
                    <div className="noResults">
                      {i18n.translate("directoryView.noResults")}
                    </div>
                  )}
                  {/* Filter duplicates, because items are created for each category and can't have multiple */}
                  {freeHotelsList.length > 0 &&
                    freeHotelsList.map((hotel, i) => (
                      <React.Fragment key={hotel.company_listing_id}>
                        <FreeHotel
                          id={hotel.company_listing_id}
                          bgImage={hotel.img_path + hotel.photo_file}
                          flyToMarker={() => {
                            this.flyToMarker(hotel.latitude, hotel.longitude);
                          }}
                          hotelInfo={() => {
                            this.freeInfo(hotel.listing_id);
                          }}
                          hotelName={hotel.company}
                          location={hotel.state}
                          item={hotel}
                        />
                      </React.Fragment>
                    ))}
                  {zoom > 8 && (
                    <div
                      className="resetMap"
                      onClick={() => {
                        this.resetMap();
                      }}
                    >
                      {i18n.translate("directoryView.resetMap")}
                    </div>
                  )}
                </div>
              </SimpleBarReact>
            </div>
          </div>
          {width > 700 && (
            <div className="rightSide">
              <LoadScript googleMapsApiKey="AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc">
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={zoom}
                  onLoad={(map) => {
                    this.map = map;
                  }}
                  onIdle={() => {
                    this.loadProperties(
                      this.map.getBounds(),
                      this.map.getZoom()
                    );
                  }}
                >
                  {/* Child components, such as markers, info windows, etc. */}
                  <MarkerClusterer
                    minimumClusterSize={4}
                    gridSize={100}
                    options={clusterFree}
                  >
                    {(clusterer) => {
                      return (
                        freeHotelsList.length > 0 &&
                        freeHotelsList.map((freeHotel) => (
                          <Marker
                            key={freeHotel.listing_id}
                            position={{
                              lat: Number(freeHotel.latitude),
                              lng: Number(freeHotel.longitude),
                            }}
                            icon={MarkerFree}
                            onClick={() => {
                              this.flyToMarker(
                                freeHotel.latitude,
                                freeHotel.longitude
                              );
                            }}
                            clusterer={clusterer}
                          />
                        ))
                      );
                    }}
                  </MarkerClusterer>
                  <MarkerClusterer
                    minimumClusterSize={5}
                    options={clusterPremium}
                  >
                    {(clusterer) => {
                      return (
                        premiumHotelsList.length > 0 &&
                        premiumHotelsList.map((premiumHotel) => (
                          <Marker
                            key={premiumHotel.id}
                            position={{
                              lat: premiumHotel.coords.latitude,
                              lng: premiumHotel.coords.longitude,
                            }}
                            icon={MarkerPremium}
                            onClick={() => {
                              this.flyToMarker(
                                premiumHotel.coords.latitude,
                                premiumHotel.coords.longitude
                              );
                            }}
                            clusterer={clusterer}
                          ></Marker>
                        ))
                      );
                    }}
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>
            </div>
          )}

          <div className="iframe hide" id="iframe">
            <div
              className="bgIframe"
              onClick={() => {
                this.closeIframe();
              }}
            ></div>
            <div className="iframeHolder">
              <div
                className="closeIframe"
                href="#"
                onClick={() => {
                  this.closeIframe();
                }}
              >
                <span className="closeText">
                  <FontAwesomeIcon icon={["fas", "chevron-left"]} />{" "}
                  {i18n.translate("general.back")}
                </span>
              </div>
              <div className="contentIframe">
                <iframe
                  width="100%"
                  height="100%"
                  id="iframeModal"
                  src={userInfo}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
